import React from 'react'
import './todos.less'
import {useIntl} from 'react-intl'
import {ToDo, dateFormat} from '../../entities/todoList'
import {ToDoCard} from './ToDoCard'
import {useRouteLoaderData} from 'react-router-dom'
import {CustomJournalEventType} from '../../entities/journalRecord'
import dayjs from 'dayjs'

type DateGroup =
  | 'overdue'
  | 'today'
  | 'tomorrow'
  | 'laterThisWeek'
  | 'laterThisMonth'
  | 'nextMonth'
  | 'later'
  | 'noDate'

const GROUP_ORDER: DateGroup[] = [
  'overdue',
  'today',
  'tomorrow',
  'laterThisWeek',
  'laterThisMonth',
  'nextMonth',
  'later',
  'noDate',
]

function getDateGroup(todo: ToDo): DateGroup {
  if (!todo.targetStartDateUtc) return 'noDate'

  const today = dayjs().startOf('day')
  const date = dayjs(todo.targetStartDateUtc, dateFormat).startOf('day')

  if (date.isBefore(today)) return 'overdue'
  if (date.isSame(today)) return 'today'
  if (date.isSame(today.add(1, 'day'))) return 'tomorrow'
  if (date.isSame(today, 'week')) return 'laterThisWeek'
  if (date.isSame(today, 'month')) return 'laterThisMonth'
  if (date.isSame(today.add(1, 'month'), 'month')) return 'nextMonth'
  return 'later'
}

export type ToDoPageToDoCardsListProps = {
  plantedPlantsNamesWithId: {id: number; name: string}[]
  unfinishedToDos: ToDo[]
}

export function ToDoPageToDoCardsList(props: ToDoPageToDoCardsListProps) {
  const intl = useIntl()

  const {userJournalEventTypes} = useRouteLoaderData('todos') as {
    userJournalEventTypes: CustomJournalEventType[]
  }

  const groups = new Map<DateGroup, ToDo[]>()
  for (const group of GROUP_ORDER) {
    groups.set(group, [])
  }
  for (const todo of props.unfinishedToDos) {
    groups.get(getDateGroup(todo))!.push(todo)
  }

  return (
    <div style={{width: '100%'}}>
      {GROUP_ORDER.map((group) => {
        const todos = groups.get(group)!
        if (todos.length === 0) return null
        return (
          <div key={group} className="todo__group">
            <h3 className="todo__group__header">
              {intl.formatMessage({id: `todoGroup-${group}`})}
            </h3>
            <div className="todo__list__cards">
              {todos.map((todo) => (
                <ToDoCard
                  todo={todo}
                  userJournalEventTypes={userJournalEventTypes}
                  key={todo.id}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
